export enum WageConditionalMethod {
  None = 0,
  Wage = 1,
  Run = 2,
  DayCount = 3,
  Miles = 4,
  WageNon6thDay = 5
}

export const WageConditionalMethodMapping: Record<WageConditionalMethod, string> = {
  [WageConditionalMethod.None]: '-- Select Method --',
  [WageConditionalMethod.Wage]: 'Earned Wage',
  [WageConditionalMethod.Run]: 'Run',
  [WageConditionalMethod.DayCount]: 'Number of Days',
  [WageConditionalMethod.Miles]: 'Miles',
  [WageConditionalMethod.WageNon6thDay]: 'Earned Wage (Non 6th)'
};
